<template>
<div class="single-table mt-5">
    <div v-if="reloading" class="spinner element-spinner d-flex flex-column justify-content-center align-items-center">
        <span class="spinner-border spinner-border-sm margin-right5" role="status" aria-hidden="true"></span>
    </div>
    <div v-if="showQueries" v-html="this.query">{{ this.query }}</div>
    <v-client-table :data="tblData" :columns="columns" :options="options">
        <template v-for="column in columns" :slot="column" slot-scope="props">
            <span :class="props.row">{{props.row[column]['value']}}</span>
        </template>
    </v-client-table>
</div>
</template>

<script>
    export default {
        props: ['hasSkb', 'tableData'],
        created() {
            this.tableData.element_abbreviation = 'social_table';
            this.fetchServerData();
            event_bus.$on('current_dwm', () => {
                this.current_dwm = this.$store.state.current_dwm;
                event_bus.$emit('reloading', true);
            });
        },
        data() {
            return {
                isArchive:this.$store.state.isArchive,
                descr:{},
                columns:[],
                options:{
                    headings:{},
                    filterable:false,
                    sortable: [],
                    texts:{
                        count:''
                    },
                    perPage: 25,
                    perPageValues:[25,50,100,1000],
                    skin: 'table'
                },
                tblData:[],
                query:'',
                showQueries:    this.$store.state.showQueries,
                reloading:true
            }
        },
        methods: {
            fetchServerData(){
                const params = {
                    'isArchive':this.isArchive,
                    'prefixed_id': this.isArchive ? this.tableData.archive_id : this.tableData.report_id,
                    'element_abbr':this.tableData.element_abbreviation,
                    'show_as_triple':false,
                    'dwm':this.$store.state.current_dwm,
                    'dates':this.$store.state.current_dates,
                    'element_id': this.tableData.element_id,
                    'prefixed_element_id': this.tableData.report_element_id,
                    'metrics': this.tableData.metrics,
                    'segment': this.tableData.segment,
                    'accounts': this.tableData.accounts,
                    'client_id':this.tableData.client_id,
                    'showQueries':this.showQueries,
                    'hasSkb':this.hasSkb
                };

                axios.post('/api/reporting/element', params).then((response) => {
                    if(!!response.data && (typeof(response.data) == 'object')){
                        let data = response.data;
                    }
                    this.reloading = false;
                });
            }
        }
    }
</script>
<style lang="scss">
    @import '~@/_variables.scss';
    div.single-table{
        .table {
            thead th{
                border-bottom:none !important;
                color:$light-blue;
                padding-bottom:2rem !important;
            }
            tbody tr {
                color:$black-blue;
                font-weight:500;
                line-height:1.5;
                &:nth-child(odd){
                    background-color:$strip-gray4;
                }
            }
        }
    }
</style>
